(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 44937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ PageAnimation; }
/* harmony export */ });
var PageAnimation = {
  init: {
    // height: "100%",
    // top: 0,
    // bottom: 'auto',
    opacity: 1,
    zIndex: 99999,
    transition: {
      duration: .2,
      ease: 'easeInOut'
    }
  },
  anim: {
    // height: "0%",
    // bottom: 0,
    // top: 'auto',
    opacity: 1,
    zIndex: -1,
    transition: {
      delay: .6,
      duration: 1,
      ease: 'easeInOut',
      zIndex: {
        delay: 1.5
      }
    }
  },
  exit: {
    opacity: 0,
    zIndex: 99999,
    transition: {
      duration: .2,
      delay: 0.4 // delayChildren: 0.3,
      // staggerChildren: .06

    }
  }
};

/***/ }),

/***/ 11267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ ApiParamKey; }
/* harmony export */ });
var ApiParamKey = {
  TYPE: 'type',
  PAGE_ID: 'page_id',
  PAGE_SLUG: 'page_slug',
  VALUE: 'value',
  GET_SECTION: 'get_section',
  IMAGE: 'image',
  POST: 'post',
  FILE: 'file',
  GALLERY: 'gallery',
  LIMIT: 'limit',
  VARIATION: 'variation',
  SPECIFICATION: 'specification',
  KEYWORD: 'keyword',
  PARENTPAGE: 'parent_page_id',
  DIVISION_ID: 'division_id',
  RADIUS: 'radius',
  KEY: 'key',
  CATEGORY_ID: 'category_id',
  DATE: 'date',
  FILTER: 'filter',
  TIME: 'timestamp',
  STARTDATE: 'start_date',
  ENDDATE: 'end_date'
};

/***/ }),

/***/ 4689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59499);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(97346);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68312);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(62642);
/* harmony import */ var _components_Title__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93264);
/* harmony import */ var _api_redux_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22657);
/* harmony import */ var _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92495);
/* harmony import */ var _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11267);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11125);
/* harmony import */ var _components_PageAnimation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44937);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);



















var Search = function Search() {
  var _getSearchData$data;

  var mobileMenuRaf = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var menuRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var hamburgerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var hamburgerCloseRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var searchClickRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var searchItemRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      border_height = _useState[0],
      setborder_height = _useState[1]; // search handle


  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      searchInput = _useState2[0],
      setSearchInput = _useState2[1];

  var handleInput = function handleInput(e) {
    setSearchInput(e.target.value);
  };

  var searchSubmit = function searchSubmit(e) {
    e.preventDefault();

    if (searchInput === '') {} else {
      var _searchItemRef$curren;

      window.location.href = "/search?keyword=".concat(searchInput);
      document.querySelector('.search-desktop').classList.remove('search-open');
      gsap__WEBPACK_IMPORTED_MODULE_10__/* .gsap.to */ .p8.to(searchItemRef.current, {
        duration: .4,
        height: 0,
        opacity: 0,
        overflow: 'hidden'
      });
      gsap__WEBPACK_IMPORTED_MODULE_10__/* .gsap.to */ .p8.to(searchItemRef === null || searchItemRef === void 0 ? void 0 : (_searchItemRef$curren = searchItemRef.current) === null || _searchItemRef$curren === void 0 ? void 0 : _searchItemRef$curren.querySelector('.container'), {
        opacity: 0
      }, '-=.4');
      gsap__WEBPACK_IMPORTED_MODULE_10__/* .gsap.to */ .p8.to(searchItemRef.current, {
        display: 'none'
      });
    } // setSearchInput('')
    // document.querySelector('.search-desktop').classList.remove('search-open')
    // gsap.to(searchItemRef.current, {
    //     duration: .4, height: 0, opacity: 0, overflow: 'hidden'
    // })
    // gsap.to(searchItemRef.current.querySelector('.container'), {
    //     opacity: 0,
    // }, '-=.4')
    // gsap.to(searchItemRef.current, {
    //     display: 'none'
    // })

  };

  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)(); // api call

  var dispath = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var searchParams = new URLSearchParams(router.asPath.split('?')[1]);
  var keyword = searchParams.get('keyword') || ''; // api call

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var api_url = _api_network_ApiServices__WEBPACK_IMPORTED_MODULE_5__/* .ApiServices.SEARCH */ .u.SEARCH;

    var param = (0,_Users_saif_dc_Dcastalia_Node_JS_Projects_shanta_security_front_end_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _api_network_ApiParamKey__WEBPACK_IMPORTED_MODULE_6__/* .ApiParamKey.KEYWORD */ .j.KEYWORD, keyword);

    if (keyword && keyword !== '') {
      setSearchInput(keyword);
    }

    dispath((0,_api_redux_search__WEBPACK_IMPORTED_MODULE_4__/* .fetchData */ .rQ)([api_url, param]));
  }, [location]);
  var getSearchData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function (state) {
    return state.search;
  }); // data
  //     const filterProduct = getSearchData?.data?.data?.filter(f => f?.type === 'product');

  var filterProduct = getSearchData === null || getSearchData === void 0 ? void 0 : (_getSearchData$data = getSearchData.data) === null || _getSearchData$data === void 0 ? void 0 : _getSearchData$data.data;
  var total = filterProduct === null || filterProduct === void 0 ? void 0 : filterProduct.length;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_12__/* .motion.div */ .E.div, {
      exit: "exit",
      animate: "anim",
      initial: "init",
      className: "page-loader pagetransition-loader",
      variants: _components_PageAnimation__WEBPACK_IMPORTED_MODULE_8__/* .PageAnimation */ .t
    }, '181'), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledSearch, {
      className: "",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "search-desktop",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          className: "search-desktop__top",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
            onSubmit: searchSubmit,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Group */ .Z.Group, {
              className: "search-input",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_14__/* ["default"].Control */ .Z.Control, {
                type: "text",
                value: searchInput,
                onChange: function onChange(e) {
                  return handleInput(e);
                },
                placeholder: 'Search'
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("button", {
                type: "submit",
                children: "Search"
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
        className: "search-result pt-100 pb-160",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_3__["default"], {
                noanim: true,
                margin: '0 0 80px 0',
                text: "Are you looking for : ".concat(keyword && keyword !== '' ? keyword : 'Nothing Found' + keyword)
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
              md: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                className: "search-result-wrap",
                children: (filterProduct === null || filterProduct === void 0 ? void 0 : filterProduct.length) > 0 ? filterProduct === null || filterProduct === void 0 ? void 0 : filterProduct.map(function (item) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: " fade-up search-result__single d-flex",
                    children: [(item === null || item === void 0 ? void 0 : item.type) === 'page' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: "".concat((item === null || item === void 0 ? void 0 : item.slug) === 'landing-page' && '/' || (item === null || item === void 0 ? void 0 : item.slug) === '' && '/' + (item === null || item === void 0 ? void 0 : item.slug) || (item === null || item === void 0 ? void 0 : item.slug) === 'downloads' && '/downloads' || (item === null || item === void 0 ? void 0 : item.slug) === 'easytrade' && '/easytrade' || (item === null || item === void 0 ? void 0 : item.slug) === 'services' && '/our-services' || (item === null || item === void 0 ? void 0 : item.slug) === 'shanta-easytrade' && '/easytrade' || (item === null || item === void 0 ? void 0 : item.slug) === 'shanta-financial-literacy-program' && '/shanta-financial-literacy-program' || (item === null || item === void 0 ? void 0 : item.slug) === 'career' && '/career' || (item === null || item === void 0 ? void 0 : item.slug) === 'about-us' && '/about' || (item === null || item === void 0 ? void 0 : item.slug) === 'contact' && '/contact' || (item === null || item === void 0 ? void 0 : item.slug) === 'downloads' && '/downloads' || (item === null || item === void 0 ? void 0 : item.slug) === 'research-center' && '/research' || (item === null || item === void 0 ? void 0 : item.slug) === 'services' && '/services')
                    }) : (item === null || item === void 0 ? void 0 : item.type) === 'research' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: '/research'
                    }) : (item === null || item === void 0 ? void 0 : item.type) === 'product' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: '/our-services'
                    }) : (item === null || item === void 0 ? void 0 : item.type) === 'product' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: '/our-services'
                    }) : (item === null || item === void 0 ? void 0 : item.category_id) === 4 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: '/research#expert'
                    }) : (item === null || item === void 0 ? void 0 : item.category_id) === 14 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: '/about#our-team'
                    }) : (item === null || item === void 0 ? void 0 : item.type) === 'page' ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
                      to: item === null || item === void 0 ? void 0 : item.slug
                    }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                      sm: 6,
                      className: "search-result__single__content p-0",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    })]
                  });
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("p", {
                  children: "It seems we can\u2019t find what you\u2019re looking for. Perhaps searching can help."
                })
              })
            })]
          })
        })
      })]
    })]
  });
};

var StyledSearch = styled_components__WEBPACK_IMPORTED_MODULE_17__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "search__StyledSearch",
  componentId: "sc-gl28qs-0"
})([".search-desktop{padding:200px 0 60px 0;background-color:#F9F9F9;display:flex;align-content:center;flex-wrap:wrap;width:100%;left:0;right:0;top:100px;z-index:9;.container{position:relative;}svg{position:absolute;top:-25px;right:-14px;font-size:22px;cursor:pointer;&:hover{color:", ";}}form{min-width:100%;.search-input{position:relative;button,p{box-shadow:none;border:none;background-color:transparent;position:absolute;right:0;top:0;bottom:0;margin:auto;height:fit-content;font-size:12px;line-height:18px;color:#221f1f;transition:color .3s ease;cursor:pointer;&:hover{color:", ";}}img{position:absolute !important;bottom:19px;margin:auto;}.form-control{border:none;border-radius:0;border-bottom:1px solid #221F1F;padding-left:0px;padding-bottom:9px;padding-top:0;height:50px;font-size:32px;line-height:36px;font-weight:500;color:#221F1F;background-color:transparent;::placeholder{font-size:32px;line-height:36px;font-weight:600;color:rgba(34,31,31,0.20);}}}}.search-desktop__menu{margin-top:23px;min-width:100%;p{font-size:12px;color:", ";font-weight:600;line-height:18px;margin-bottom:13px;}ul{display:inline-flex;li{a{font-size:16px;font-weight:600;line-height:22px;color:#221f1f;display:flex;margin-right:30px;}&:nth-last-child(1){a{margin-right:0;}}}}}@media (max-width:992px){padding:120px 0 60px 0 !important;}}.search-result-wrap{width:100%;}.search-result{&__single{position:relative;margin-bottom:40px;padding-bottom:40px;border-bottom:1px solid rgba(34,31,31,0.30);a{position:absolute;height:100%;width:100%;top:0;left:0;z-index:2;}&__content{h2{font-size:26px;font-weight:bold;line-height:32px;margin:0 0 26px 0;transition:color .4s ease;}p{font-size:16px;font-weight:600;line-height:22px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;}}&__img{height:160px;div{width:100%;height:100%;}img{position:static;max-width:100%;max-height:100%;object-fit:contain;}}&:hover{h2{color:", ";}}}}@media (max-width:550px){.search-desktop form .search-input .form-control{padding-left:30px;font-size:20px;line-height:25;padding-right:0px;&::placeholder{font-size:20px;line-height:25;}}.search-result__single{flex-wrap:wrap;flex-direction:column-reverse;&__content{min-width:100%;}&__img{min-width:100%;margin:0 0 20px 0;span{max-width:200px !important;min-width:200px !important;img{max-width:fit-content !important;min-width:fit-content !important;margin:0 !important;left:15px !important;}}}}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_18__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (Search);

/***/ }),

/***/ 32252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(4689);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1125,9774,2888,179], function() { return __webpack_exec__(32252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);